import { render } from "./RemittanceHistory.vue?vue&type=template&id=db2a7ef6"
import script from "./RemittanceHistory.vue?vue&type=script&lang=js"
export * from "./RemittanceHistory.vue?vue&type=script&lang=js"

import "./RemittanceHistory.vue?vue&type=style&index=0&id=db2a7ef6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__